import type { AnomalyQuery } from "./api";

export function exportUrl(params: AnomalyQuery = {}): string {
  const search = new URLSearchParams();
  if (params.q) search.set("q", params.q);
  if (params.type) search.set("type", params.type);
  if (params.featureId) search.set("featureId", params.featureId);
  if (params.yearFrom != null) search.set("yearFrom", String(params.yearFrom));
  if (params.yearTo != null) search.set("yearTo", String(params.yearTo));
  if (params.hasCoords) search.set("hasCoords", "true");
  const value = search.toString();
  return value ? `/api/export?${value}` : "/api/export";
}
